/* eslint-disable no-underscore-dangle */
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import React from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { ReactComponent as CookieIcon } from '../../../images/svg/icon_cookie-button.svg'

import { setCookieInitializedNoPreferences, setCookiePreferences, setCookieReady } from '../../../flux/actions/tracking'
import { initAdv } from '../../../flux/sagas/adv/initAdv'
import { selectLabel } from '../../../flux/selectors/i18n'
import { selectIsPreferenceExpressed } from '../../../flux/selectors/tracking'
import { selectIsCampaignExpired, selectIsWebView } from '../../../flux/selectors/ux'
import { OT_ALL_PREFERENCES } from '../../../helpers/const'
import { getCampaignDataFromUrl } from '../../../helpers/getInfoFromUrl'
import {
  getActivePreferences,
  initOneTrust,
  isPreferenceExpressed as isCookiePreferenceExpressed,
  openPreferences,
} from '../../../helpers/oneTrustCMP'
import getContext from '../../../utils/context/getContext'
import { getSecret } from '../../../utils/i18n/secret'

const StyledRoot = styled('div')(({ theme: { spaces }, isVisible }) => ({
  display: isVisible ? 'block' : 'none',
  height: spaces.large,
  width: spaces.large,
  '&:hover': {
    cursor: 'pointer',
  },
}))

const CookieConsent = ({ isWebView, isPreferenceExpressed }) => {
  const dispatch = useDispatch()
  const isCampaignExpired = useSelector(selectIsCampaignExpired)
  const { country } = getCampaignDataFromUrl()
  const cookieLabels = useSelector(selectLabel('cookiebar'))
  const context = getContext()

  React.useEffect(() => {
    const lang = getSecret('LOCALE')({ country })
    const domain = getSecret('ONE_TRUST_DOMAIN')({ country, context })
    const isCookiebarVisibile = (
      isWebView !== undefined && !isWebView
      && country && cookieLabels
      && isCampaignExpired === false
    )

    if (isCookiebarVisibile) {
      initOneTrust({
        domain,
        lang,
        onActivationDone: () => {
          initAdv()
          dispatch(setCookiePreferences(
            isCookiePreferenceExpressed(),
            getActivePreferences(),
          ))
          dispatch(setCookieReady())
        },
        onReady: () => {
          if (isCookiePreferenceExpressed()) {
            dispatch(setCookieReady())
          } else {
            dispatch(setCookieInitializedNoPreferences())
          }
        },
      })
    }

    if (isWebView) {
      const preferences = OT_ALL_PREFERENCES
      dispatch(setCookiePreferences(true, preferences))
      dispatch(setCookieReady())
      initAdv()
    }
  }, [isWebView, cookieLabels, isCampaignExpired])

  return isWebView !== undefined && !isWebView && country ? (
    <StyledRoot isVisible={isPreferenceExpressed}>
      <CookieIcon onClick={openPreferences} />
    </StyledRoot>
  ) : null
}

const mapStateToProps = state => ({
  isWebView: selectIsWebView(state),
  isPreferenceExpressed: selectIsPreferenceExpressed(state),
})

CookieConsent.propTypes = {
  isWebView: PropTypes.bool,
  isPreferenceExpressed: PropTypes.bool,
}

CookieConsent.defaultProps = {
  isWebView: undefined,
  isPreferenceExpressed: false,
}

export default connect(mapStateToProps)(CookieConsent)
